// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './translations/i18n'
import vSelect from 'vue-select'

Vue.config.productionTip = false
Vue.component('v-select', vSelect)

let params = []

if (window.startLink) {
  params = window.startLink.substr(1).split('/')
} else {
  params.push(23000019669)
  params.push('ru_RU')
}

Vue.prototype.$categoryId = params[0]
Vue.prototype.$lang = params[1]
Vue.prototype.$uid = window.location.href.match(new RegExp('(?:[?&]uid=)([^&]+)'))

/* eslint-disable no-new */
window.vm = new Vue({
  i18n,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js